import {
  allAdminRoles,
  allowedRolesForBuildingInformationComment,
  utilityTunnelAdminRoles,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";

const notAllowedStatusForComment = [
  "Saved",
  "Rejected",
  "Connection Released",
  "Application Process Completed",
];

export const isCommentInputVisible = (
  status,
  roles,
  isCommented,
  isFireSafety = false,
  isUtilityTunnel = false
) => {
  if (
    isAuthorizedUser(
      roles,
      isFireSafety
        ? allowedRolesForBuildingInformationComment
        : isUtilityTunnel
        ? utilityTunnelAdminRoles
        : allAdminRoles
    )
  ) {
    return !notAllowedStatusForComment.includes(status);
  }
  return !notAllowedStatusForComment.includes(status) && isCommented;
};
